import { i18n } from "@/plugins/i18n"
import { config } from "/app.config"

// adLocatorName: only where the show has ad settings (not under a station)
// originalFileName: the file uploaded before the MP3 conversion, only while that conversion is on
export const makeEpisodeRoutes = ({ listName, createName, detailName, editName, adLocatorName, originalFileName, parent }) => [
  {
    path: "episodes",
    component: () => import("@/views/Podcasts/Episodes/PodcastEpisodes.vue"),
    children: [
      {
        path: "",
        name: listName,
        component: () => import("@/views/Podcasts/Episodes/PodcastEpisodeList.vue"),
        meta: {
          pageTitle: i18n.t("episodes.list_title"),
          parent,
          rule: "owner",
        },
      },
      {
        path: "create",
        name: createName,
        component: () => import("@/views/Podcasts/Episodes/PodcastEpisodeAdd.vue"),
        props: true,
        meta: {
          pageTitle: i18n.t("episodes.add_title"),
          parent,
          rule: "owner",
        },
      },
      {
        path: ":episodeKey",
        name: detailName,
        component: () => import("@/views/Podcasts/Episodes/PodcastEpisode.vue"),
        props: true,
        meta: {
          pageTitle: i18n.t("episodes.detail_title"),
          parent,
          rule: "owner",
        },
        children: [
          {
            path: "edit",
            name: editName,
            component: () => import("@/views/Podcasts/Episodes/PodcastEpisodeEdit.vue"),
            props: true,
            meta: {
              pageTitle: i18n.t("episodes.settings_title"),
              parent,
              rule: "owner",
            },
          },
          ...(config.podcastTranscode && originalFileName
            ? [
                {
                  path: "original-file",
                  name: originalFileName,
                  component: () => import("@/views/Podcasts/Episodes/PodcastEpisodeOriginalFile.vue"),
                  meta: {
                    pageTitle: i18n.t("episodes.original_file.title"),
                    parent,
                    rule: "owner",
                  },
                },
              ]
            : []),
          ...(adLocatorName
            ? [
                {
                  path: "ad-locator",
                  name: adLocatorName,
                  component: () => import("@/views/Podcasts/Episodes/PodcastEpisodeAdLocator.vue"),
                  meta: {
                    pageTitle: i18n.t("podcasts.ad_locator.title"),
                    parent,
                    rule: "owner",
                  },
                },
              ]
            : []),
        ],
      },
    ],
  },
]
